import type { CtaFieldLimitApi } from "@/lib/api";

export type FieldCheck = { level: "error" | "warn"; message: string } | null;

/**
 * Mesma regra do servidor (cta_catalogs.FIELD_LIMITS): fora do limite fisico o valor
 * nao e salvo; fora do usual e so um aviso, porque exemplares excepcionais existem.
 */
export function checkField(limit: CtaFieldLimitApi | undefined, value: number | null | undefined): FieldCheck {
  if (!limit || value === null || value === undefined || Number.isNaN(value)) return null;
  const unit = limit.unit ? ` ${limit.unit}` : "";
  const lowOk = limit.min_exclusive ? value > limit.min : value >= limit.min;
  if (!lowOk || value > limit.max) {
    const rule = limit.min_exclusive
      ? `maior que ${limit.min} e no máximo ${limit.max}${unit}`
      : `entre ${limit.min} e ${limit.max}${unit}`;
    return { level: "error", message: `Deve ser ${rule}. Este valor não será salvo.` };
  }
  if (limit.plausible_max !== undefined && value > limit.plausible_max) {
    return { level: "warn", message: `Acima do usual (${limit.plausible_max}${unit}). Confira a medida e a unidade.` };
  }
  if (limit.plausible_min !== undefined && value < limit.plausible_min) {
    return { level: "warn", message: `Abaixo do usual (${limit.plausible_min}${unit}). Confira a medida e a unidade.` };
  }
  return null;
}

/** Atributos nativos do input, para o teclado e o navegador ja barrarem o obvio. */
export function limitAttrs(limit: CtaFieldLimitApi | undefined) {
  return limit ? { min: limit.min, max: limit.max, step: limit.step } : {};
}

export function inputStateCls(check: FieldCheck): string {
  if (check?.level === "error") return "border-danger-400 focus:border-danger-400 focus:ring-danger-200";
  if (check?.level === "warn") return "border-warning-400";
  return "";
}

export default function FieldLimitHint({ check }: { check: FieldCheck }) {
  if (!check) return null;
  return (
    <p
      className={`text-[11px] mt-1 flex gap-1 ${check.level === "error" ? "text-danger-600" : "text-warning-700"}`}
      role={check.level === "error" ? "alert" : undefined}
    >
      <i className={check.level === "error" ? "ri-error-warning-line" : "ri-alert-line"}></i>
      {check.message}
    </p>
  );
}
